export const VISITOR_REGISTRATION_PATH = '/visitor-registration' as const;
export const ROOT_PATH = `${VISITOR_REGISTRATION_PATH}/:ownerType/:ownerId` as const;
export const VISITS_SUB_PATH = 'visits' as const;
export const ERROR_PATH = '/error' as const;
